import { render, staticRenderFns } from "./CarcraftLogo.vue?vue&type=template&id=c197404a&scoped=true"
import script from "./CarcraftLogo.vue?vue&type=script&lang=js"
export * from "./CarcraftLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c197404a",
  null
  
)

export default component.exports